import { DEVICE } from '@/define/Adapter';

const useragent = window.navigator.userAgent;

const is = (platform: string) => {
  const reg = new RegExp(`(${platform})`, 'ig');
  return reg.test(useragent);
};

// base

export const isIPhone = () => is('iPhone');

export const isAPhone = () => is('android') && is('mobile');

export const isIPad = () => is('iPad');

export const isMiniprogram = () => is('miniprogram');

// 待确定useragent
export const isATV = () => is('android') && is('tv');

export const isAPad = () => is('android') && !is('mobile') && !isATV();

export const isPanda = () => is('Panda');

// combo
export const isMobile = () => isIPhone() || isAPhone() || isAPad() || isIPad() || isMiniprogram();

export const isIOS = () => isIPhone() || isIPad();

export const isAndroid = () => isAPhone() || isAPad();

export const isPandaIPhone = () => isPanda() && isIPhone();

export const isPandaAPhone = () => isPanda() && isAPhone();

export const isPandaIOS = () => isPanda() && isIOS();

export const isPandaAndroid = () => isPanda() && isAndroid();

export const isPC = () => !isMobile() && !isATV() && !isMiniprogram();

//

const deviceState: Map<DEVICE, boolean> = new Map();

deviceState.set(DEVICE.Mobile, isMobile());
deviceState.set(DEVICE.PC, isPC());
deviceState.set(DEVICE.TV, isATV());

const allDevices = [DEVICE.Mobile, DEVICE.PC, DEVICE.TV];

export const getMatchDevice = (devices: DEVICE[] = allDevices) => {
  const matchDevice = devices.find((device) => deviceState.get(device));
  return matchDevice;
};
